import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import cssModal from '../../../modal/modalPartilhar.module.css';
import { ReactComponent as Fechar } from '../../../../assets/icons/modal/fechar.svg';
import { useCookies } from 'react-cookie';
import { getInfoPopUp } from '../../../../api/apiEmpresa';

export default function PopUp({ infoJson }) {
  const [show, setShow] = useState(true);
  const [cookies, setCookie] = useCookies(['cookie-popUp']);
  const [url, setUrl] = useState({ UrlPopup: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (cookies.popUp) {
      setShow(false);
    }
  }, [cookies.popUp]);

  useEffect(() => {
    const getAllUrl = async () => {
      try {
        const url = await getInfoPopUp(infoJson);
        setUrl(url);
      } catch (error) {
        console.error('Error fetching Url:', error);
        // Handle error if needed
      } finally {
        setLoading(false); // Set loading to false after the request is completed
      }
    };

    getAllUrl();
  }, [infoJson]);

  const onDismiss = () => {
    setShow(false);
    if (infoJson.Stand.PopUp.Cookie && url.UrlPopup === '') {
      setCookie('popUp', true, { maxAge: 86400 });
    }
  };

  return (
    <>
      {loading ? (
        <></>
      ) : (infoJson.Stand.PopUp.Existe && !cookies.popUp) || url?.UrlPopup ? (
        <Modal centered show={show} size="lg" fullscreen={'md-down'} onHide={() => onDismiss()}>
          <Modal.Body>
            <div onClick={() => onDismiss()} className={` ${cssModal.close} close`}>
              <Fechar />
            </div>
            <img
              className="w-100 h-auto"
              src={url.UrlPopup ? url?.UrlPopup : infoJson.Stand.PopUp.Src}
              alt="pop up"
            />
          </Modal.Body>
        </Modal>
      ) : null}
    </>
  );
}
